import { Injectable } from "@angular/core";
import {
  CreateCustomWidgetPostDto,
  DefaultWidgetGetDto,
  LocationWidgetSettingsGetDto,
  LocationWithDefaultWidgetGetDto,
  WidgetMode
} from "clearline-api";
import { WidgetType } from "clearline-common";
import { Subject } from "rxjs";
@Injectable()
export class MarketingAppsSettingsService {
  private emptyCustomApp$ = new Subject<LocationWithDefaultWidgetGetDto>();

  readonly createCustomAppAction$ = this.emptyCustomApp$.asObservable();

  sendCreateCustomMappAction(baseWidgetType: WidgetType = WidgetType.SmartPage): void {
    const defaultWidgetSettings: DefaultWidgetGetDto = {
      id: null,
      name: "Custom App",
      description: null,
      notificationKey: null,
      packageId: null,
      isWidget: false,
      isCampaign: false,
      isAvailableForConditions: false,
      isAvailableForKiosk: false,
      useForUnified: false,
      useForClickableTemplate: false,
      useOnCfs: false,
      deliveryMethod: null,
      videoId: null
    };
    const locationWidgetSettings: LocationWidgetSettingsGetDto = {
      id: null,
      locationId: null,
      defaultWidgetSettingsId: baseWidgetType,
      notificationKey: null,
      disabled: false,
      disabledOnCfs: false,
      deliveryMethod: null,
      configured: false,
      widgetSettingsJson: "{}",
      defaultWidgetSettings
    };

    const baseCustomApp: LocationWithDefaultWidgetGetDto = {
      icon: null,
      description: null,
      overrided: false,
      isOutOfThePlan: false,
      defaultWidgetSettings,
      widget: {
        id: null,
        name: "",
        description: null,
        mode: WidgetMode.Custom
      },
      locationWidgetSettings
    };

    this.emptyCustomApp$.next(baseCustomApp);
  }

  generateCustomAppPayload(widgetDto: LocationWithDefaultWidgetGetDto, wSettings: LocationWidgetSettingsGetDto): CreateCustomWidgetPostDto {
    const { locationWidgetSettings, description } = widgetDto;
    const { deliveryMethod, widgetSettingsJson } = wSettings;
    const widgetSettings = JSON.parse(widgetSettingsJson);

    return {
      name: widgetSettings?.appName,
      description: description,
      deliveryMethod: deliveryMethod,
      configuration: widgetSettingsJson,
      disabled: !!locationWidgetSettings.disabled,
      disabledOnCfs: !!locationWidgetSettings.disabled,
      configured: true,
      widgetTypeSettingId: locationWidgetSettings.defaultWidgetSettingsId
    };
  }
}
